// extracted by mini-css-extract-plugin
module.exports = {"qsConfirmAntdModal":"Pz2Fz","qsBasicAntdModal":"v4nv2","modalOkBtn":"OOmhO","modalCancelBtn":"F2YA4","mobileQsBasicAntdModal":"_4UQzW"};